import { render, staticRenderFns } from "./RoleDataruleModal.vue?vue&type=template&id=6df2f441&scoped=true&"
import script from "./RoleDataruleModal.vue?vue&type=script&lang=js&"
export * from "./RoleDataruleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2f441",
  null
  
)

export default component.exports